<app-nav-bar></app-nav-bar>
<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>

<div class="container">
  <div class="container-giftcards">
    <div class="nav-tab-container">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <a class="nav-link" id="home-tab" [routerLink]="['/giftCardTypes']" routerLinkActive="active" role="tab" aria-controls="home" aria-selected="true"> {{'GIFT_CARDS_TYPES' | translate}}</a>
        </li>
        <li class="nav-item" role="presentation">
          <a class="nav-link" id="home-tab" [routerLink]="['/giftCardItems']" routerLinkActive="active" role="tab" aria-controls="home" aria-selected="true">{{'GIFT_CARDS' | translate}}</a>
        </li>
      </ul>
    </div>
    <div class="header">
      <h1 class="title">
        {{ isCreating ? ('CREATE_GIFT_CARD' | translate) : (isViewingDetail ? ('GIFT_CARD' | translate) : ('GIFT_CARDS' | translate)) }}
      </h1>

      <button *ngIf="isViewingList" type="button" class="btn btn-outline-primary primary-btn" (click)="showCreateView()">{{'CREATE' | translate}}</button>
      <app-back-arrow-settings *ngIf="!isViewingList" (click)="showListView()"></app-back-arrow-settings>
    </div>
    <app-create-gift-card-items *ngIf="isCreating"></app-create-gift-card-items>
    <div *ngIf="isViewingList" class="form-card">
      <div class="loading" *ngIf="loading">
        <div class="spinner-border" role="status"></div>
      </div>
      <table *ngIf="!loading" class="table table-bordered table-hover">
        <thead>
          <th scope="col" class="table-start">ID</th>
          <th scope="col">{{'AMOUNT' | translate}}</th>
          <th scope="col">{{'CODE' | translate}}</th>
          <th scope="col">{{'CODE' | translate}}</th>
          <th scope="col" class="table-end">{{'STATUS' | translate}}</th>
        </thead>
        <tbody>
          <tr *ngFor="let giftCard of giftCards" (click)="showDetailView(giftCard.giftCardId)">
            <td class="gift-card-id">
              {{ giftCard.giftCardId }}
            </td>
            <td>{{ appComponent.formatMoney(giftCard.amount) }}</td>
            <td>{{ formatDate(giftCard.date) }}</td>
            <td>{{ giftCard.code }}</td>
            <td>
              {{ giftCard.status === 0 ? ('INACTIVE' | translate) : (giftCard.status === 1 ? ('ACTIVE' | translate) : ('PENDING' | translate)) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-gift-cards-item *ngIf="isViewingDetail" [giftCardId]="selectedGiftCardId !== null ? selectedGiftCardId.toString() : ''"></app-gift-cards-item>
  </div>
</div>
<app-footer></app-footer>